import type { ReactNode } from 'react';
import { CarFront } from 'lucide-react';
import { Badge, DetailPageHeader } from '@shared/components';
import { AgreementKeyFacts } from '../AgreementKeyFacts';
import { thirdPartyBalanceText, thirdPartyStartDateText } from '../../utils/thirdPartyAgreementView';
import type { ThirdPartyAgreement } from '../../types/thirdPartyAgreement.types';

interface Props {
    agreement: ThirdPartyAgreement;
    tabs: ReactNode;
}

export function ThirdPartyAgreementHeader({ agreement, tabs }: Props) {
    return (
        <DetailPageHeader
            breadcrumbs={[{ label: 'Agreements', to: '/agreements' }, { label: agreement.reference }]}
            title={agreement.reference}
            icon={CarFront}
            badges={
                <>
                    {agreement.status !== null && <Badge variant="outline">{agreement.status}</Badge>}
                    <Badge size="xs" variant="info">
                        Third Party
                    </Badge>
                </>
            }
            subtitle={
                <AgreementKeyFacts
                    startDate={thirdPartyStartDateText(agreement.startDate)}
                    availableBalance={thirdPartyBalanceText(agreement.balanceGrossMinor)}
                />
            }
            tabs={tabs}
        />
    );
}
